(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbDescriptionPanel', lbDescriptionPanelDirective);

    function lbDescriptionPanelDirective() {
        return {
            restrict: 'EA',
            replace:true,
            scope: {
                panel:'='
            },
            templateUrl: "common/libraries/layoutBuilder/panels/description"
        };
    }
})();